module.exports = ".max_width{\n    width: 100%;\n}\n"